import { useEffect } from 'react'
import { useCookies } from 'react-cookie'

export const useUrlQueryToCookie = ({ params, queryName, cookieName }) => {
  const [, setCookie] = useCookies([cookieName])

  useEffect(() => {
    if (params.hasOwnProperty(queryName)) {
      setCookie(cookieName, params[queryName], { path: '/' })
    }
    // todo fix lint issue
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params])
}
